<template>
    <svg
        version="1.1"
        id="_x33_4C4DA2344107B65_xA0_Image_00000049935489509435970820000011167516676324199343_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 422 633"
        style="enable-background: new 0 0 422 633"
        xml:space="preserve"
    >
        <image
            style="overflow: visible"
            width="422"
            height="633"
            id="_x33_4C4DA2344107B65_xA0_Image"
            xlink:href="5EAB7B8BE45180F2.jpg"
        ></image>
    </svg>
</template>
<script>
export default {
    name: "UspaPoloAt",
};
</script>



// WEBPACK FOOTER //
// src/components/V2/uspaV2/asset/UspaAt.vue